import template from './checkbox.html';

function CheckboxComponent() {
	'ngInject';

	const directive = {
		template,
		'restrict': 'E',
		'transclude': true,
		'scope': {
			'model': '=',
			'inputName': '@inputName'
		}
	};

	return directive;
}

export default CheckboxComponent;



/** WEBPACK FOOTER **
 ** ./client/components/checkbox/checkbox.directive.js
 **/